// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-message[data-v-a3a5199a]{font-size:17px;line-height:2}.info-alert[data-v-a3a5199a]{font-size:13px;color:#f85b5b;line-height:1.1}.task-status-img[data-v-a3a5199a]{width:100%;height:auto;image-rendering:-webkit-optimize-contrast}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
